import Grid from '@mui/material/Grid';
import type { FunctionComponent, PropsWithChildren } from 'react';

export const TableCellWrapper: FunctionComponent<PropsWithChildren> = ({ children }) => (
    <Grid alignItems="center" container={true} height="36px">
        {children}
    </Grid>
);
